<template>
  <Modal v-model="openMap" footer-hide width="340">
    <div id="share">
      <Row :gutter="16">
        <Col span="24">
          <h3>位置分享：{{ item.carNo }}</h3>
        </Col>
        <Col span="24">
          <p>分享时长：{{ now }}小时（{{ utils.time(item.endTime) }}截止）</p>
          <div id="qucliy">
            <a
              @click="end(x)"
              v-for="(x, index) in shichang"
              :key="index"
              :class="{ active: now == x }"
              >{{ x }}小时</a
            >
          </div>
        </Col>
        <Col span="12">
          <Button long type="primary" @click="share">立即分享</Button>
        </Col>
        <Col span="12">
          <Button long @click="endshare">结束分享</Button>
        </Col>
      </Row>
    </div>
    <shareMakeCode ref="shareMakeCode"></shareMakeCode>
  </Modal>
</template>
<script>
import axios from "axios";
import shareMakeCode from "./shareMakeCode.vue";
export default {
  components: { shareMakeCode },
  data() {
    return {
      openMap: false,
      item: {
        deviceNo: "",
        carNo: "",
        href: "",
        endTime: new Date(),
      },
      shichang: [1, 2, 4, 8, 12, 24, 36, 48, 72],
      ruleValidate: {
        endTime: { required: true, message: "必填" },
      },
      now: 2,
    };
  },
  methods: {
    open(v) {
      this.item.carNo = v.carNo;
      this.item.deviceNo = v.deviceNo;
      this.openMap = true;
    },

    end(t) {
      this.now = t;
      var now = Date.now();
      var to = t * 3600000;
      this.item.endTime = new Date(now + to);
    },
    share() {
      this.utils.loading(this, "生成中");
      let params = {
        deviceNo: this.item.deviceNo,
        expiredTime: this.item.endTime.getTime(),
      };
      this.axios({
        method: "post",
        url: this.axios.lbs + "/share/start",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (res) {
            var data = res.data.data;

            this.item.href = data;
            if (data != null) {
              this.openMap = false;
              this.$refs.shareMakeCode.makeCode(this.item);
            }
          }
        }
      });
    },
    endshare() {
      let params = {
        deviceNo: this.item.deviceNo,
      };
      this.axios({
        method: "post",
        url: this.axios.lbs + "/share/end",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (res) {
            this.reset();
          }
        }
      });
    },
    reset() {
      this.openMap = false;
      this.item.href = "";
    },
  },
  mounted() {
    this.end(this.now);
  },
};
</script>
<style lang="">
#share {
  width: 310px;
}
#share h3 {
  font-size: 18px;
  margin-bottom: 20px;
}
#qucliy {
  margin-bottom: 34px;
  margin-top: 10px;
}
#qucliy a {
  display: inline-block;
  background: #fff;
  margin: 2px;
  width: 100px;
  text-align: center;
  line-height: 24px;
}
#qucliy a.active {
  background: #d1eaf7;
}
#qucliy a:nth-child(3n) {
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/share/index.vue